// @owner ClientPlatform

export enum SsoPage {
  LOGIN = 'login',
  NEW_LOGIN = 'new-login',
  CALLBACK = 'callback',
}
